import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TopBarComponent } from '.';
import { LayoutComponent } from './components/layout/layout.component';

const MODULES = [
  CommonModule,
  RouterModule
]

const COMPONENTS = [
  TopBarComponent,
  LayoutComponent
]

@NgModule({
  declarations: [
    ...COMPONENTS,
    
    
  ],
  imports: [
    ...MODULES
  ],
  exports: [
    ...COMPONENTS
  ]
})
export class SharedModule { }
